export default "__VITE_ASSET__ad432b05__"